export { default } from './InfoBarContainer';
